// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__7gxtI","item":"PaymentsMobile_item__2XcON","label":"PaymentsMobile_label__UMQwy","amount":"PaymentsMobile_amount__FRBIv"};